export function ProductsLoader() {
  return (
    <div className="text-primary-default relative flex h-full min-h-[300px] w-full items-center justify-center">
      <span className="border-primary-default size-10 animate-spin rounded-full border-2 border-t-transparent" />
    </div>
  );
}
